<template>
    <Content>
        <figure>
            <a :href="product.url_pro">
                <VueLoadImage>
                    <img
                        slot="image"
                        :src="product.image_main"
                        :title="product.pro_name_site"
                        :alt="product.pro_name_site"
                    />
                    <img
                        slot="preloader"
                        :src="$baseUrl + 'assets/images/loading-image.gif'"
                    />
                    <div slot="error">Erro ao carregar a imagem</div>
                </VueLoadImage>
            </a>
        </figure>

        <div class="product-principal-cart">
            <h2>
                <a :href="product.url_pro">
                    <template v-if="showCodeOriginal">
                        {{ product.api_cod_original }} -
                    </template>
                    {{ product.pro_name_site }}
                </a>
            </h2>

            <template v-if="!product.is_product_group">
                <p v-if="product.size_name_cart">
                    <strong>Tamanho:</strong> {{ product.size_name_cart }}
                </p>
                <p v-if="product.color_name_cart">
                    <strong v-if="product.type == 'COLOR'">Cor:</strong>
                    <strong v-if="product.type == 'ESTAMPA'">Estampa:</strong>
                    {{ product.color_name_cart }}
                </p>

                <template v-if="product.items_grid_abbreviaton">
                    <p>{{ product.items_grid_abbreviaton }}</p>
                </template>
                <template v-else>
                    <p
                        v-if="product.grid_group_column_value"
                        class="text-capitalize"
                    >
                        <strong>
                            {{ product.grid_group_column_name.toLowerCase() }}:
                        </strong>
                        {{ product.grid_group_column_value }}
                    </p>
                    <p
                        v-if="product.grid_group_row_value"
                        class="text-capitalize"
                    >
                        <strong>
                            {{ product.grid_group_row_name.toLowerCase() }}:
                        </strong>
                        {{ product.grid_group_row_value }}
                    </p>
                </template>

                <p v-if="product.flavors && product.flavors.length">
                    <strong>
                        {{ product.flavors.length > 1 ? "Sabores" : "Sabor" }}:
                    </strong>
                    <span
                        v-for="flavor in product.flavors"
                        :key="flavor.id"
                        class="cart__flavor"
                    >
                        {{ flavor.name }}
                    </span>
                </p>
            </template>

            <p v-if="product.additional_product_file" class="additional-files">
                <a
                    v-if="fileNotImage(product.additional_product_file_name)"
                    :href="product.additional_product_file"
                    target="_blank"
                >
                    <i class="fas fa-link"></i>

                    <strong>{{ product.additional_product_file_name }}</strong>
                </a>
                <i
                    v-else
                    class="far fa-image"
                    @click="handleOpenModalImage(product)"
                ></i>
            </p>
        </div>

        <div
            v-if="product.additional_product_observation"
            class="additional-product-observation"
        >
            <p>
                <strong>Observações:</strong>
                {{ product.additional_product_observation }}
            </p>
        </div>
    </Content>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Content } from "./style";
import VueLoadImage from "vue-load-image";

export default {
    name: "CartItemProduct",
    props: {
        product: {
            required: true
        }
    },
    components: {
        Content,
        VueLoadImage
    },
    methods: {
        ...mapActions("modalCarousel", ["setImagesModalCarousel"]),
        fileNotImage(file_name) {
            return (
                file_name.search(/.+\.pdf$/) >= 0 ||
                file_name.search(/.+\.cdr$/) >= 0 ||
                file_name.search(/.+\.psd$/) >= 0
            );
        },
        handleOpenModalImage(product) {
            let images = [
                {
                    image: product.additional_product_file,
                    alt: product.pro_name_site
                }
            ];
            this.setImagesModalCarousel(images);
            this.$root.showModalApp("modal_carousel_images");
        }
    },
    computed: {
        ...mapGetters("company", [
            "showCodeOriginalBesideDescription",
            "getShowUnitOfMeasureInProductPrice"
        ]),
        showCodeOriginal() {
            return (
                this.showCodeOriginalBesideDescription &&
                this.product.api_cod_original
            );
        }
    }
};
</script>
